import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33c50641"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=33c50641&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../eazy-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports